import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../auth/service/auth.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @Input() pageTitle:any;
  @Input() tallNav:any;
  @Input() home:any;
  isDashboard = false;
  showAside = false;
  constructor(
    private authService: AuthService,
    private location: Location,
    public router: Router,
    public route:ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      this.showAside = false;
    });

  }

  logout(): void {
    this.authService.logout();
  }
  onBack() {
    let navigated = false;


    // live well
    if(this.router.url.includes('/live-well/') ){
      this.router.navigate(['/']);
      navigated = true;
    }

    // programme
    if(this.router.url.includes('/programme/') ){
      this.router.navigate(['/programme']);
      navigated = true;
    }

    // move well
    if(this.router.url.includes('/activity/steps/') ){
      this.router.navigate(['/activity', 'steps']);
      navigated = true;
    }
    if(this.router.url.includes('/activity/fit/') ){
      this.router.navigate(['/activity', 'fit']);
      navigated = true;
    }
    if(this.router.url.includes('/activity/move/') ){
      this.router.navigate(['/activity', 'move']);
      navigated = true;
    }
    if(this.router.url.includes('/activity/breathe/') ){
      this.router.navigate(['/activity', 'breathe']);
      navigated = true;
    }

    // move well catch all
    if(!navigated && this.router.url.includes('/activity')){
      this.router.navigate(['/activity']);
      navigated = true;

    }


    // other modules

    if(this.router.url.includes('/modules/i-quit/') ){
      this.router.navigate(['/modules', 'i-quit']);
      navigated = true;
    }
    if(this.router.url.includes('/modules/drinking-guide/') ){
      this.router.navigate(['/modules', 'drinking-guide']);
      navigated = true;
    }
    if(this.router.url.includes('/modules/feel-well/') ){
      this.router.navigate(['/modules', 'feel-well']);
      navigated = true;
    }
    if(this.router.url.includes('/modules/sleep-well/') ){
      this.router.navigate(['/modules', 'sleep-well']);
      navigated = true;
    }
    if(this.router.url.includes('/modules/eat-well/') ){
      this.router.navigate(['/modules', 'eat-well']);
      navigated = true;
    }

    if(!navigated && this.router.url.includes('/modules/') ){
      this.router.navigate(['/',]);
      navigated = true;
    }

    // social
    if(this.router.url.includes('/social/forum/category/') ){
      this.router.navigate(['/social', 'forum']);
      navigated = true;
    }
    if(!navigated && this.router.url.includes('/social/forum') && !this.router.url.includes('/social/forum/topic') ){
      this.router.navigate(['/social']);
      navigated = true;
    }
    if(!navigated && this.router.url.includes('/social/') && !this.router.url.includes('/social/forum/topic') ){
      this.router.navigate(['/social']);
      navigated = true;
    }

    if(!navigated){
      this.location.back();
    }
  }
  onToggleAsideMenu() {
    this.showAside = !this.showAside;
  }
  onCloseMenu(event:any){
    this.showAside = false;
  }
}
